import {createElement as h, Fragment} from "react";
import {joinArr} from "../utils/collections";

export const joinJsx = (elements, delimiter) => h(Fragment,{}, ...joinArr(elements, delimiter));